export default "__VITE_ASSET__32506254__"